export default __webpack_public_path__ + "locales/pt/SharingPanel.json?hash=e989655a1fe56420e2204da1dd363b57";